import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListUserComponent } from './list-user/list-user.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { TeachersComponent } from './teachers/teachers.component';
import { UserActiveComponent } from './user-active/user-active.component';
import { UserQueryComponent } from './user-query/user-query.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ListUserComponent,
        data: { title: 'User List', breadcrumb: 'User List' }
      },
      {
        path: 'create-user',
        component: CreateUserComponent,
        data: { title: 'Create User', breadcrumb: 'Create User' }
      },
      {
        path: 'teachers',
        component: TeachersComponent,
        data: { title: 'Instructores', breadcrumb: 'Instructores' }
      },
      {
        path: 'active-users',
        component: UserActiveComponent,
        data: { title: 'Consulta de Usuarios Activos', breadcrumb: 'Consulta de Usuarios Activos' }
      },
      {
        path: 'consulta',
        component: UserQueryComponent,
        data: { title: 'Consulta de Usuarios', breadcrumb: 'Consulta de Usuarios' }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
